/*
    创建者：shuxiaokai
    创建时间：2020-05-13 11:38
    模块名称：日期选择item
    备注：xxxx
*/
<template>
    <div>
        <slot />
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">

</style>
